import axiosInstance from "./axiosInstance";

const API_URL = process.env.REACT_APP_API_URL;

export const getEventDelays = async () => {
  try {
    const response = await axiosInstance.get(`${API_URL}/event-delays`);
    return response.data;
  } catch (error) {
    console.error(
      "Error fetching event delays:",
      error.response?.data || error,
    );
    throw error;
  }
};

export const getEventDelayById = async (id) => {
  try {
    const response = await axiosInstance.get(`${API_URL}/event-delays/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching event delay:", error.response?.data || error);
    throw error;
  }
};

export const getEventDelayByEventId = async (eventId) => {
  try {
    const response = await axiosInstance.get(
      `${API_URL}/event-delays/event/${eventId}`,
    );
    return response.data;
  } catch (error) {
    console.error(
      "Error fetching event delays by event ID:",
      error.response?.data || error,
    );
    throw error;
  }
};

export const getEventDelayByEventIds = async (eventIds = []) => {
  if (!eventIds.length) {
    return [];
  }

  try {
    const response = await axiosInstance.get(
      `${API_URL}/event-delays/by-event-ids`,
      {
        params: { eventIds: eventIds.join(",") },
      },
    );
    return response.data;
  } catch (error) {
    console.error(
      "Error fetching event delays by event IDs:",
      error.response?.data || error,
    );
    throw error;
  }
};

export const createEventDelay = async (data) => {
  try {
    const response = await axiosInstance.post(`${API_URL}/event-delays`, data);
    return response.data;
  } catch (error) {
    console.error("Error creating event delay:", error.response?.data || error);
    throw error;
  }
};

export const updateEventDelay = async (id, data) => {
  try {
    const response = await axiosInstance.put(
      `${API_URL}/event-delays/${id}`,
      data,
    );
    return response.data;
  } catch (error) {
    console.error("Error updating event delay:", error.response?.data || error);
    throw error;
  }
};

export const deleteEventDelay = async (id) => {
  try {
    const response = await axiosInstance.delete(
      `${API_URL}/event-delays/${id}`,
    );
    return response.data;
  } catch (error) {
    console.error("Error deleting event delay:", error.response?.data || error);
    throw error;
  }
};
